import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {
  Collapse,
  Navbar,
  NavItem,
  Nav,
  Container,
} from 'reactstrap';
import { Notifications } from './Notifications';
import { isAuthenticated } from '../../../api/helper'
import { connect } from 'react-redux';
import { SelectLanguage } from './SelectLanguage';
import { ProfileDropdown } from "./ProfileDropdown/index";

class HeaderComponent extends React.Component {
  render() {
    const { isAuthenticated } = this.props;
    return (
      <>
        <Navbar className="navbar-top navbar-expand border-bottom navbar-dark bg-theme-primary">
          <Container fluid>
            <Collapse navbar isOpen={ true }>
              <Nav className="align-items-center ml-md-auto" navbar>
                <NavItem className="dashboard-layout__mobile-toggle-item d-xl-none">
                  <button
                    aria-controls="left-side-bar"
                    aria-expanded={this.props.sidenavOpen}
                    aria-label="Toggle navigation"
                    className={
                      classnames(
                        "dashboard-layout__mobile-toggle btn btn-link p-0 mr-3 sidenav-toggler sidenav-toggler-dark active-links-color",
                        { active: this.props.sidenavOpen },
                      )
                    }
                    onClick={ this.props.toggleSidenav }
                    type="button"
                  >
                    <div className="sidenav-toggler-inner active-links-color">
                      <i className="sidenav-toggler-line active-links-color" />
                      <i className="sidenav-toggler-line active-links-color" />
                      <i className="sidenav-toggler-line active-links-color" />
                    </div>
                  </button>
                </NavItem>

                <Notifications />

                <SelectLanguage />
              </Nav>
              { isAuthenticated && <ProfileDropdown /> }
            </Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

HeaderComponent.defaultProps = {
  sidenavOpen: false,
  isAuthenticated: isAuthenticated(),
};

HeaderComponent.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
};

const mapStateToProps = state => ({
});

const mapActionsToProps = {
  isAuthenticated,
};

const Header = connect(mapStateToProps, mapActionsToProps)(HeaderComponent);

export { HeaderComponent, Header };
